import { ThemeProvider } from '@mui/material'
import { SnackbarProvider } from 'notistack'
import React from 'react'
import { useSelector } from 'react-redux'
import { RouterProvider } from 'react-router-dom'
import './App.scss'
import { SnackbarNotification } from './Components/Notifications/SnackbarNotification'
import MUIAlert from './Components/Shared/MUI-Alert'
import { logger } from './Helpers'
import { MUITheme } from './Helpers/MUI'
import router from './Routes'

function App() {
  const state = useSelector((s: any) => s.alert)
  logger.info('Env: ', process.env.REACT_APP_ENV)

  return (
    <SnackbarProvider
      maxSnack={5}
      dense={true}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      Components={{
        snackbarNotification: SnackbarNotification,
      }}
    >
      <ThemeProvider theme={MUITheme()}>
        <RouterProvider router={router} />
        <MUIAlert state={state.alertProps} />
      </ThemeProvider>
    </SnackbarProvider>
  )
}

export default React.memo(App)
